const ColorLegend = ({color, text, size = 12}) => (
    <div style={{display: "inline-flex", alignItems: "center", gap: 6}}>
        <span
            aria-hidden="true"
            style={{
                width: size,
                height: size,
                backgroundColor: color,
                border: "1px solid rgba(0, 0, 0, 0.25)",
                borderRadius: 2,
                flexShrink: 0,
            }}
        />
        <span>{text}</span>
    </div>
);

export default ColorLegend;
